var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");

var _objectWithoutProperties = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _excluded = ["size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _extends() {
  return _extends = Object.assign || function (a) {
    for (var b, c = 1; c < arguments.length; c++) {
      for (var d in b = arguments[c], b) {
        Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
      }
    }

    return a;
  }, _extends.apply(this, arguments);
}

var React = require("react");

module.exports = function (a) {
  var _a$size = a.size,
      c = _a$size === void 0 ? "1em" : _a$size,
      b = _objectWithoutProperties(a, _excluded);

  return b = _objectSpread(_objectSpread({}, b), {}, {
    style: _objectSpread(_objectSpread({}, b.style ? b.style : {}), {}, {
      width: c,
      height: c
    })
  }), /*#__PURE__*/React.createElement("svg", _extends({}, b, {
    id: "tensorflow-original-wordmark-tensorflow-original-wordmark-svg961",
    preserveAspectRatio: "xMidYMid meet",
    version: "1.1",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("defs", {
    id: "tensorflow-original-wordmark-tensorflow-original-wordmark-defs950"
  }, /*#__PURE__*/React.createElement("text", {
    id: "tensorflow-original-wordmark-tensorflow-original-wordmark-a1aRu5gk7c",
    style: {
      lineHeight: "100%"
    },
    fontFamily: "Open Sans",
    fontSize: "18",
    transform: "translate(-107.803 -55.017)",
    x: "130.64",
    y: "54.4",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tensorflow-original-wordmark-tensorflow-original-wordmark-tspan946",
    dy: "0em",
    textAnchor: "start",
    x: "130.64"
  }, "TensorFlow")), /*#__PURE__*/React.createElement("path", {
    id: "tensorflow-original-wordmark-tensorflow-original-wordmark-auEC81zEw",
    d: "M5.75 20.16V7.09L0 10.41l.01-4.95L9.57 0v22.38l-3.82-2.22zm4.68 2.22l3.82-2.22v-6.29l2.88 1.66-.02-4.3-2.86-1.64v-2.5L20 10.41l-.01-4.95L10.43 0v22.38z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tensorflow-original-wordmark-tensorflow-original-wordmark-g959"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tensorflow-original-wordmark-tensorflow-original-wordmark-g2923",
    fillOpacity: "1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tensorflow-original-wordmark-tensorflow-original-wordmark-g954",
    fill: "#ff6f00",
    transform: "translate(0 51.288) scale(1.136)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "tensorflow-original-wordmark-tensorflow-original-wordmark-use952",
    style: {
      lineHeight: "normal",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: "0",
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: "0",
      shapeMargin: "0",
      inlineSize: "0",
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: "1"
    },
    d: "M5.75 20.16V7.09L0 10.41l.01-4.95L9.57 0v22.38zm4.68 2.22l3.82-2.22v-6.29l2.88 1.66-.02-4.3-2.86-1.64v-2.5L20 10.41l-.01-4.95L10.43 0z",
    fill: "#ff6f00",
    fillOpacity: "1",
    fontFamily: "sans-serif",
    fillRule: "nonzero",
    fontSize: "medium",
    opacity: "1",
    stopColor: "#000",
    stopOpacity: "1",
    stroke: "none",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: "4",
    strokeOpacity: "1",
    strokeWidth: "1",
    textAnchor: "start",
    vectorEffect: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tensorflow-original-wordmark-tensorflow-original-wordmark-b4lQe9xgno",
    fill: "#425066",
    transform: "translate(-1.71 56.287) scale(1.136)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tensorflow-original-wordmark-tensorflow-original-wordmark-use956",
    style: {
      lineHeight: "100%"
    },
    fill: "#425066",
    fillOpacity: "1",
    fontFamily: "Open Sans",
    fillRule: "nonzero",
    fontSize: "medium",
    stroke: "none",
    strokeDasharray: "none",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: "4",
    strokeOpacity: "1",
    strokeWidth: "1",
    textAnchor: "start"
  }, /*#__PURE__*/React.createElement("path", {
    id: "tensorflow-original-wordmark-tensorflow-original-wordmark-path2273",
    style: {
      lineHeight: "100%",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: "0",
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: "0",
      shapeMargin: "0",
      inlineSize: "0",
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: "1"
    },
    d: "M32.479 2.518h-3.621v10.828h-2.092V2.518h-3.612V.743h9.325z",
    opacity: "1",
    stopColor: "#000",
    stopOpacity: "1",
    vectorEffect: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "tensorflow-original-wordmark-tensorflow-original-wordmark-path2275",
    style: {
      lineHeight: "100%",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: "0",
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: "0",
      shapeMargin: "0",
      inlineSize: "0",
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: "1"
    },
    d: "M39.967 9.4h-6.135c.024.832.279 1.474.765 1.925.492.451 1.166.677 2.021.677.961 0 1.843-.287 2.646-.862v1.644c-.82.516-1.904.773-3.252.773-1.324 0-2.364-.407-3.12-1.221-.75-.82-1.125-1.972-1.125-3.454 0-1.4.413-2.54 1.24-3.42.831-.884 1.862-1.327 3.093-1.327 1.23 0 2.182.396 2.856 1.187.674.791 1.011 1.89 1.011 3.296zm-1.969-1.44c-.006-.733-.178-1.301-.518-1.705-.34-.41-.809-.616-1.407-.616-.585 0-1.084.214-1.494.642-.404.428-.653.987-.747 1.679z",
    opacity: "1",
    stopColor: "#000",
    stopOpacity: "1",
    vectorEffect: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "tensorflow-original-wordmark-tensorflow-original-wordmark-path2277",
    style: {
      lineHeight: "100%",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: "0",
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: "0",
      shapeMargin: "0",
      inlineSize: "0",
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: "1"
    },
    d: "M49.925 13.346h-2.04v-5.07c0-1.683-.594-2.523-1.783-2.523-.621 0-1.134.234-1.538.703-.405.463-.607 1.049-.607 1.758v5.132H41.91v-9h2.048v1.495h.035c.674-1.137 1.647-1.706 2.918-1.706.979 0 1.726.32 2.242.958.515.633.773 1.55.773 2.751z",
    opacity: "1",
    stopColor: "#000",
    stopOpacity: "1",
    vectorEffect: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "tensorflow-original-wordmark-tensorflow-original-wordmark-path2279",
    style: {
      lineHeight: "100%",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: "0",
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: "0",
      shapeMargin: "0",
      inlineSize: "0",
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: "1"
    },
    d: "M51.85 13.065v-1.89c.762.58 1.602.87 2.522.87 1.23 0 1.846-.363 1.846-1.09a.84.84 0 00-.158-.518 1.461 1.461 0 00-.43-.386 3.187 3.187 0 00-.634-.3 100.7 100.7 0 01-.808-.298 8.924 8.924 0 01-1.002-.466 3.199 3.199 0 01-.739-.554 2.191 2.191 0 01-.439-.712c-.1-.263-.15-.57-.15-.922 0-.434.103-.815.308-1.143.205-.334.48-.612.826-.835a3.817 3.817 0 011.178-.51c.44-.117.894-.176 1.362-.176.832 0 1.577.126 2.233.378v1.785c-.633-.434-1.36-.65-2.18-.65a2.9 2.9 0 00-.703.078c-.205.053-.38.126-.527.22a1.06 1.06 0 00-.343.343.786.786 0 00-.123.43.93.93 0 00.123.493c.082.134.202.255.36.36.164.1.358.193.58.281.229.082.49.173.783.273.386.158.732.32 1.037.483.31.164.574.352.79.563.217.205.384.445.502.72.117.27.175.592.175.967 0 .457-.105.856-.316 1.195-.21.34-.492.622-.844.844a3.871 3.871 0 01-1.221.492 6.11 6.11 0 01-1.45.167c-.985 0-1.837-.164-2.558-.492z",
    opacity: "1",
    stopColor: "#000",
    stopOpacity: "1",
    vectorEffect: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "tensorflow-original-wordmark-tensorflow-original-wordmark-path2281",
    style: {
      lineHeight: "100%",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: "0",
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: "0",
      shapeMargin: "0",
      inlineSize: "0",
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: "1"
    },
    d: "M64.163 13.557c-1.388 0-2.499-.419-3.33-1.256-.827-.844-1.24-1.96-1.24-3.35 0-1.51.43-2.691 1.292-3.541.867-.85 2.033-1.275 3.498-1.275 1.406 0 2.502.414 3.287 1.24.785.826 1.178 1.971 1.178 3.436 0 1.436-.425 2.587-1.275 3.454-.843.862-1.98 1.292-3.41 1.292zm.097-7.796c-.797 0-1.427.279-1.89.835-.463.557-.694 1.325-.694 2.303 0 .944.234 1.688.703 2.233.469.539 1.096.808 1.881.808.803 0 1.418-.266 1.846-.8.433-.533.65-1.292.65-2.276 0-.99-.217-1.755-.65-2.294-.428-.539-1.043-.809-1.846-.809z",
    opacity: "1",
    stopColor: "#000",
    stopOpacity: "1",
    vectorEffect: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "tensorflow-original-wordmark-tensorflow-original-wordmark-path2283",
    style: {
      lineHeight: "100%",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: "0",
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: "0",
      shapeMargin: "0",
      inlineSize: "0",
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: "1"
    },
    d: "M76.143 6.289c-.246-.194-.6-.29-1.064-.29-.603 0-1.107.272-1.511.817-.405.545-.607 1.286-.607 2.224v4.306h-2.039v-9h2.04v1.855h.034c.2-.633.504-1.125.914-1.477.416-.357.88-.536 1.389-.536.37 0 .65.056.844.167z",
    opacity: "1",
    stopColor: "#000",
    stopOpacity: "1",
    vectorEffect: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "tensorflow-original-wordmark-tensorflow-original-wordmark-path2285",
    style: {
      lineHeight: "100%",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: "0",
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: "0",
      shapeMargin: "0",
      inlineSize: "0",
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: "1"
    },
    d: "M84.615 2.518h-4.71v3.788h4.341v1.767h-4.342v5.273h-2.091V.743h6.802z",
    opacity: "1",
    stopColor: "#000",
    stopOpacity: "1",
    vectorEffect: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "tensorflow-original-wordmark-tensorflow-original-wordmark-path2287",
    style: {
      lineHeight: "100%",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: "0",
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: "0",
      shapeMargin: "0",
      inlineSize: "0",
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: "1"
    },
    d: "M88.676 13.346h-2.048V.022h2.048z",
    opacity: "1",
    stopColor: "#000",
    stopOpacity: "1",
    vectorEffect: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "tensorflow-original-wordmark-tensorflow-original-wordmark-path2289",
    style: {
      lineHeight: "100%",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: "0",
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: "0",
      shapeMargin: "0",
      inlineSize: "0",
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: "1"
    },
    d: "M95.32 13.557c-1.388 0-2.499-.419-3.33-1.256-.827-.844-1.24-1.96-1.24-3.35 0-1.51.43-2.691 1.292-3.541.867-.85 2.033-1.275 3.498-1.275 1.406 0 2.502.414 3.287 1.24.786.826 1.178 1.971 1.178 3.436 0 1.436-.425 2.587-1.274 3.454-.844.862-1.98 1.292-3.41 1.292zm.097-7.796c-.797 0-1.427.279-1.89.835-.462.557-.694 1.325-.694 2.303 0 .944.235 1.688.703 2.233.47.539 1.096.808 1.881.808.803 0 1.418-.266 1.846-.8.433-.533.65-1.292.65-2.276 0-.99-.217-1.755-.65-2.294-.428-.539-1.043-.809-1.846-.809z",
    opacity: "1",
    stopColor: "#000",
    stopOpacity: "1",
    vectorEffect: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "tensorflow-original-wordmark-tensorflow-original-wordmark-path2291",
    style: {
      lineHeight: "100%",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontVariantEastAsian: "normal",
      fontFeatureSettings: "normal",
      fontVariationSettings: "normal",
      textIndent: "0",
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      textTransform: "none",
      textOrientation: "mixed",
      whiteSpace: "normal",
      shapePadding: "0",
      shapeMargin: "0",
      inlineSize: "0",
      isolation: "auto",
      mixBlendMode: "normal",
      solidColor: "#000",
      solidOpacity: "1"
    },
    d: "M114.182 4.346l-2.654 9h-2.136l-1.635-6.1a3.86 3.86 0 01-.123-.79h-.035a3.663 3.663 0 01-.158.773l-1.776 6.117h-2.092l-2.645-9h2.11l1.634 6.487c.053.193.088.45.105.773h.062c.018-.246.064-.51.14-.79l1.82-6.47h1.916l1.617 6.513c.053.205.091.463.114.774h.062c.012-.217.056-.475.132-.774l1.6-6.513z",
    opacity: "1",
    stopColor: "#000",
    stopOpacity: "1",
    vectorEffect: "none"
  }))))));
};